import ReadingsChart from '../../../components/readings-chart'
import merge from 'lodash.merge';
import roundTo from 'round-to'

const humidityChart = (chartEl, options = {}) => {

  options = merge({
    label: 'Humidity',
    source: 'humidity',
    borderColor: '#1f339b',
    backgroundColor: '#3a5fcd',
    tickFormat: (value, index, values) => {
      return roundTo(value, 1) + '%';
    },
    tooltipFormat: context => {
      return context.parsed.y + '%';
    },
    valueConversion: value => {
      return parseFloat(value).toFixed(1);
    },
  }, options);

  const chart = new ReadingsChart(chartEl, options);

};

export default humidityChart;
